import { render, staticRenderFns } from "./EmSppSparePartsCatSpcList.vue?vue&type=template&id=08ae97d5&"
import script from "./EmSppSparePartsCatSpcList.vue?vue&type=script&lang=js&"
export * from "./EmSppSparePartsCatSpcList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports